import React from 'react';
import { Typography } from '@mui/material';

interface PatientNameTemplateProps {
  firstName?: string | null;
  lastName?: string | null;
}

/**
 * Displays patient full name.
 */
export const PatientNameTemplate: React.FC<PatientNameTemplateProps> = ({ firstName, lastName }) => {
  const fullName = `${firstName || ''} ${lastName || ''}`.trim();
  return (
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {fullName || '-'}
    </Typography>
  );
};

/** Syncfusion grid template wrapper */
export const patientNameTemplate = (props: { firstName?: string | null; lastName?: string | null }) => (
  <PatientNameTemplate firstName={props.firstName} lastName={props.lastName} />
);

export default PatientNameTemplate;
